/* global Sys, Core */
Sys.ns("Core.Slots");

/**
 * The Server Manager controller for slots.
 *
 * @class Core.Slots.ServerManagerController
 * @extends Core.ServerManagerController
 */
Core.Slots.ServerManagerController = {
    constructor: function() {
        Core.Slots.ServerManagerController.superclass.constructor.apply(this, arguments);
    },

    /**
     * Extends the base functionality to get the parsed server responses.
     *
     * @protected
     * @inheritdoc
     */
    setupEvents: function() {
        var me = this;

        Core.Slots.ServerManagerController.superclass.setupEvents.apply(this, arguments);

        me.on({
            "notify:responseParser.responseParsed": me.storeNextAction,
            "notify:settingsManager.settingChanged": me.onSettingsChanged
        });
    },

    onSettingsChanged: function(setting, value) {
        if (setting === "betLevel" || setting === "denomination" || setting === "betLines") {
            this.model.storeData("parameters:" + setting, value);
        }
    },

    /**
     * Extends the base functionality to allow for specifying "nextAction" as action.
     *
     * @private
     * @param {string} action The action name (must be specified exactly as the action parameter in the server request should).
     * @param {string} [parsingCompleteEvent] Optional custom event to be fired instead of "notify:responseParser.responseParsed".
     * @returns {void}
     */
    sendAction: function(action, parsingCompleteEvent) {
        action = (action === "nextAction") ? this.model.readData("nextAction") : action;

        Core.Slots.ServerManagerController.superclass.sendAction.call(this, action, parsingCompleteEvent);
    },

    /**
     * Store the next action to enable "nextAction" to be specified as the action for requests.
     *
     * @param {Object} parsedServerResponse Parsed server response.
     * @returns {void}
     */
    storeNextAction: function(parsedServerResponse) {
        this.model.storeData("nextAction", parsedServerResponse.nextaction);
    }
};

Core.Slots.ServerManagerController = Sys.extend(Core.ServerManagerController, Core.Slots.ServerManagerController, "Core.Slots.ServerManagerController");
